<template>
    <div class="row">
        <div class="col-md-3">
            <label for="">Status:</label>
            <select name="" id="" class="form-control" v-model="status" @change="changeData">
                <option value="">TODOS</option>
                <option value="ABERTO">Aberto</option>
                <option value="ENVIADO">Enviado</option>
                <option value="DELETADO">Deletado</option>
            </select>
        </div>

        <div class="col-md-3">
            <div class="form-group">
                <label for=""> Revendedoras: </label>
                <select name="" id="" class="form-control" v-model="revendedora" @change="changeData">
                    <option value="0">Todas</option>
                    <option v-for="revend in revendedoras" :value="revend.id" :key="revend.id">
                        {{ revend.nome }}
                        <span v-if="revend.pdv"> ( {{ revend.pdv.nome }} )</span>
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <label for="">De:</label>
                <date-picker :disabled="status === 'ABERTO'" v-model="fromDate" @dp-change="changeData"></date-picker>
            </div>
        </div>

        <div class="col-md-3">
            <div class="form-group">
                <label for="">Até:</label>
                <date-picker :disabled="status === 'ABERTO'" v-model="toDate" @dp-change="changeData"></date-picker>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <b-button v-if="status === 'ABERTO' && !checkBonificado()" class="ml-1 float-right" variant="danger"
                    size="sm" @click="deletarPedido">
                    <i class="fas fa-trash"></i> Deletar Pedidos
                </b-button>
                <!-- <b-button v-if="status === 'ABERTO' && profile.pdv == null" class="ml-1 float-right" variant="success"
                    size="sm" @click="enviarPedido">
                    <i class="fas fa-paper-plane"></i> Enviar Pedidos
                </b-button> -->
                <b-button v-if="status === 'ABERTO' && profile.pdv == null" class="ml-1 float-right" variant="success"
                    size="sm" @click="abrirModalDados">
                    <i class="fas fa-paper-plane"></i> Enviar Pedidos
                </b-button>

                <b-button variant="danger" class="ml-1 float-right" v-if="status === 'DELETADO' && profile.pdv == null"
                    size="sm" @click="recuperarDeletados">
                    <i class="fas fa-undo"></i> Recuperar Pedidos
                </b-button>
            </div>
        </div>

        <b-card class="col-md-12 mt-1">
            <div v-if="valor_acao_comercial > 0" class="card-acao-comercial mb-3 position-relative overflow-hidden">
                
                <div v-if="acao_comercial_enviada" class="overlay-brindes">
                    <div class="text-center">
                        <i class="fas fa-check-circle text-success mb-2" style="font-size: 2rem;"></i>
                        <h4 class="text-success font-weight-bold mb-0">Brindes já inseridos no Lote {{ acao_comercial_enviada }}</h4>
                    </div>
                </div>
                <div class="cabecalho-acao">
                    <h5 class="titulo">Ação Comercial em Andamento</h5>
                </div>

                <p class="descricao">
                    Alcance um crescimento de <strong>10%</strong> sobre o seu último mês e antecipe seus pedidos para antes do dia <strong>15</strong>! Cumprindo esses requisitos, você ganha o equivalente a <strong>6%</strong> do valor de envio do mês em brindes.
                </p>

                <span class="text-warning mb-2"><i class="fas fa-info-circle mb-2" style="font-size: 1rem;"></i> Produtos Encarte (sem desconto) não contabilizam para o programa de incentivo</span>

                <div class="area-progresso">
                    <div class="info-progresso">
                        <span>
                            Progresso: <strong>{{ totalItensIncentivo + acao_comercial_enviado_itens }}</strong> 
                            de <strong>{{ meta_esperada }}</strong> <small class="text-muted ml-1">(sendo {{ valor_acao_comercial }} + 10%)</small> itens 
                        </span>
                        <span class="porcentagem">{{ porcentagem_concluida }}%</span>
                    </div>

                    <div class="barra-fundo">
                        <div 
                            class="barra-preenchimento" 
                            :style="{ width: porcentagem_concluida + '%' }"
                        ></div>
                    </div>
                </div>
            </div>

            <b-card-header v-if="status === 'ABERTO' || status === 'DELETADO'">
                <p class="text-left">
                    <strong class="text-primary">Pedidos Selecionados: </strong>{{ checkBonificado() ? enviar.length - 1
                        :
                    enviar.length }}
                    <strong class="text-primary"> | </strong>
                    <strong class="text-primary">Itens Selecionados: </strong>{{ totalItensSelecionados }}
                </p>
                <div v-if="errors.length > 0">
                    <div class="row" v-for="(erro, e) in errors" :key="e">
                        <div class="alert alert-danger">{{ errors }}</div>
                    </div>
                </div>
            </b-card-header>
            <b-card-body>
                <b-table :per-page="perPage" :busy="isLoading" hover striped responsive :fields="colunas"
                    :items="dataTable" :current-page="currentPage">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    <template #head(id)>
                        <b-form-checkbox v-model="todosMarcado" :indeterminate="indeterminate"
                            v-if="status === 'ABERTO' || status === 'DELETADO'" :value="true"
                            @change="changeMarcarTodos"></b-form-checkbox>
                    </template>
                    <template #cell(id)="row">
                        <b-form-checkbox stacked v-if="status === 'ABERTO' || status === 'DELETADO'" v-model="enviar"
                            :value="row.value" :key="row.value" @change="changeMarcar(row.item)"></b-form-checkbox>
                    </template>
                    <template #cell(lote)="row">
                        <a :href="'/lotes/' + row.value" target="_blank" v-if="row.value && !profile.pdv">{{ row.value
                            }}</a>
                    </template>
                    <template #cell(opcoes)="row">
                        <b-button variant="primary" class="mt-1" v-if="status === 'ABERTO'" title="Visualizar Pedido"
                            @click="showPedido(row.item.id)">
                            <i class="fas fa-eye"></i>
                        </b-button>
                        <downloadexcel :name="filename" :worksheet="`${row.item.nome}`" class="btn btn-success mt-1"
                            title="Exportar Pedido" :fetch="() => { return startDownload(row.item.id) }"
                            :before-generate="exportExcel" :before-finish="finishExcel">
                            <i class="far fa-file-excel"></i>
                        </downloadexcel>
                        <b-button variant="warning" class="mt-1" v-if="status === 'ABERTO'" title="Editar Pedido"
                            @click="editPedido(row.item)">
                            <i class="fas fa-edit"></i>
                        </b-button>
                        <b-button variant="danger" class="mt-1" v-if="status === 'ABERTO' && !row.item.bonificacao"
                            title="Deletar Pedido" @click="deletarPedidoLinha(row.item.id)">
                            <i class="fas fa-trash"></i>
                        </b-button>

                    </template>
                </b-table>
                <b-pagination v-if="pedidos.length > 19" v-model="currentPage" :total-rows="totalRows"
                    :per-page="perPage" align="center" class="my-0"></b-pagination>
            </b-card-body>
        </b-card>
        
                <!-- MODAL DE ATUALIZAR CADASTRO EMAIL E TELEFONE MC 1-->
        
        <b-modal v-model="cadPopModal" size="lg" title="Confirmação de Dados" hide-footer  v-if="profile.email !== undefined ">
            <b-card>
                <div class="row mb-3">
                    <label>Atualize seus dados pessoais. Insira seu email e telefone para contato.</label>
                </div>
                <!-- INPUT EMAIL -->
                <div class="list-group-item">
                    <label>E-mail para contato:</label>
                    <div class="row">
                        <div class="col-md-7">
                            <b-form-group id="input-group-1" label="Confirme seu email:" label-for="input-1" description="Endereço de e-mail válido">
                                <b-form-input id="input-1" v-model="profile.email" type="email" placeholder="email@email.com"/>
                            </b-form-group>
                        </div>
                        </div>
                </div>
                <!-- INPUT TELEFONE 1 -->
                <div class="list-group-item" v-if="profile.contatos && profile.contatos[0] ">
                    <label>Telefone atual:</label>
                    <div class="row">
                <div class="col-md-2">
                    <b-form-input  v-mask="['(##)']" id ="input-1" v-model="profile.contatos[0].telefone.ddd" type="phone" placeholder="DDD" required />
                        </div>
                <div class="col-md-5">
                    <b-form-input v-mask="['# ####-####', '#####-####', '####-####']" id="input-1" v-model="profile.contatos[0].telefone.numero" type="phone" placeholder="Somente o numero sem o ddd"/>
                </div>
                </div>
                </div>
                <!-- INPUT TELEFONE 2 -->
                <div class="list-group-item" v-if="profile.contatos && profile.contatos[1]">
                <div class="row">
                <div class="col-md-2 mt-2">
                    <b-form-input v-mask="['(##)']" id ="input-1" v-model="profile.contatos[1].telefone.ddd" type="phone" placeholder="DDD" required />
                        </div>
                <div class="col-md-5 mt-2">
                    <b-form-input  v-mask="['# ####-####', '#####-####', '####-####']" id="input-1" v-model="profile.contatos[1].telefone.numero" type="phone" placeholder="Somente o numero sem o ddd"/>
                </div>
                </div>
                </div>
                
                <div class="row mt-3">
                    <label>Os campos de e-mail e telefone são opcionais. Caso os dados estejam corretos, pode prosseguir normalmente.</label>
                </div>
                    <!-- BOTAO MODAL -->
                <b-form @submit.prevent="onSubmitCad">
                    <b-button @click="confirmarEnvioPedido" type="submit" variant="primary" class="ml-1 float-right"><i class="fas fa-save"></i> Salvar</b-button>
                    <b-button variant="secondary" class="ml-1 mb-15 float-right" @click="cadPopModal = false"> Cancelar </b-button>
                </b-form>
            </b-card>
        </b-modal> 

        <!---------------- Modal de envio ------------->
        <b-modal hide-footer no-close-on-backdrop hide-header no-close-on-esc no-enforce-focus no-stacking
            v-model="modalEnvio" size="lg">
            <b-row>
                <h2>Enviando os pedidos, NÃO atualize a página!</h2>
            </b-row>
            <div class="text-center">
                <img src="/images/send-order.gif" alt="send">
            </div>
            <!-- <b-progress height="20px" :max="enviar.length">
                        <b-progress-bar :value="loadProgresso">
                            <span>{{ porcent }} % </span>
                        </b-progress-bar>
                    </b-progress>
                    <div class="text-center mt-2">
                        <b-spinner variant="primary" small></b-spinner>
                        <span>Enviando
                            <strong>{{ loadProgresso }} de {{ enviar.length }}</strong>
                        </span>
                    </div> -->
        </b-modal>

        <b-modal 
            id="chose-modal" 
            size="xl"
            header-bg-variant="light"
            title="Ação Comercial - Escolha seus brindes"
            scrollable
            centered
        >
            <b-container fluid class="px-0">
                <b-row>
                    <b-col md="8" class="pr-md-4">
                        <h5 class="mb-4 border-bottom pb-2">Produtos Disponíveis</h5>
                        
                        <b-row>
                            <b-col md="4" sm="6" v-for="produto in produtos" :key="produto.id" class="mb-4">
                                <b-card 
                                    no-body
                                    class="h-100 text-center product-card border-0 shadow-sm"
                                >
                                    <b-card-img 
                                        :src="produto.imagem ? produto.imagem : 'https://placehold.co/300x200?text=Sem+Imagem'" 
                                        top
                                        class="product-img"
                                    ></b-card-img>

                                    <b-card-body class="d-flex flex-column p-3">
                                        <h6 class="text-truncate mb-1" :title="`(${produto.codigo}) ${produto.nome}`">{{ `(${produto.codigo}) ${produto.nome}` }}</h6>
                                        <h5 class="text-primary font-weight-bold mb-3">
                                            R$ {{ Number(produto.pivot.preco).toFixed(2) }}
                                        </h5>
                                        
                                        <div class="mt-auto">
                                            <b-input-group size="sm" class="mb-2 w-75 mx-auto">
                                                <b-input-group-prepend is-text>Qtd</b-input-group-prepend>
                                                <b-form-input 
                                                    type="number" 
                                                    v-model.number="produto.quantidadeTemp" 
                                                    min="1" 
                                                    class="text-center"
                                                ></b-form-input>
                                            </b-input-group>
                                            
                                            <b-button 
                                                variant="primary" 
                                                size="sm"
                                                class="w-100 font-weight-bold"
                                                @click="adicionarAoCarrinho(produto)"
                                                :disabled="(totalCarrinho + (Number(produto.pivot.preco) * (produto.quantidadeTemp || 1))) > limiteValor"
                                            >
                                                Adicionar
                                            </b-button>
                                        </div>
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col md="4">
                        <div class="bg-light rounded p-3 d-flex flex-column border">
                            <h5 class="mb-3 border-bottom pb-2">Seu Carrinho</h5>
                            
                            <div v-if="carrinho.length === 0" class="text-center text-muted my-auto py-5">
                                <p>Seu carrinho está vazio.<br></p>
                            </div>

                            <div class="cart-scroll-area flex-grow-1" v-else>
                                <b-list-group flush>
                                    <b-list-group-item 
                                        v-for="item in carrinho" 
                                        :key="item.id"
                                        class="bg-transparent px-0 py-2 border-bottom"
                                    >
                                        <div class="d-flex justify-content-between align-items-start mb-1">
                                            <strong class="text-truncate mr-2">{{ `(${item.codigo}) ${item.nome}` }}</strong>
                                            <b-button variant="link" class="text-danger p-0 text-decoration-none" @click="removerDoCarrinho(item)" title="Remover">
                                                🗑️
                                            </b-button>
                                        </div>
                                        
                                        <div class="d-flex justify-content-between align-items-center">
                                            <small class="text-muted">R$ {{ Number(item.pivot.preco).toFixed(2) }} /un</small>
                                            
                                            <b-form-input 
                                                type="number" 
                                                v-model.number="item.quantidade" 
                                                min="1" 
                                                size="sm"
                                                class="cart-qty-input text-center"
                                                @change="validarQuantidadeCarrinho(item)"
                                            ></b-form-input>
                                        </div>
                                    </b-list-group-item>
                                </b-list-group>
                            </div>

                            <div class="mt-4 pt-3 border-top">
                                <div class="d-flex justify-content-between mb-2">
                                    <span class="font-weight-bold text-muted">Total:</span>
                                    <h5 class="font-weight-bold text-primary mb-0">
                                        R$ {{ totalCarrinho.toFixed(2) }}
                                    </h5>
                                </div>
                                <div class="d-flex justify-content-between mb-1">
                                    <small class="text-muted">Limite disponível:</small>
                                    <small class="font-weight-bold">R$ {{ limiteValor.toFixed(2) }}</small>
                                </div>
                                
                                <b-progress class="mt-2 shadow-sm" height="8px">
                                    <b-progress-bar 
                                        :value="totalCarrinho" 
                                        :max="limiteValor" 
                                        :variant="progressoVariante"
                                    ></b-progress-bar>
                                </b-progress>
                                
                                <div style="height: 20px;" class="mt-1 text-center">
                                    <small v-if="totalCarrinho >= limiteValor" class="text-danger font-weight-bold fade-in">
                                        ⚠️ Limite de valor atingido!
                                    </small>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <template #modal-footer="{ close }">
                <b-button variant="outline-secondary" @click="close()">
                    Cancelar
                </b-button>
                <b-button variant="success" class="px-4" @click="confirmarCarrinho">
                    Confirmar Seleção
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import downloadexcel from "vue-json-excel";
import moment from 'moment';
export default {
    props: [
        "campanha_atual",
        "acao_comercial",
        "acao_comercial_enviada"
    ],
    components: {
        downloadexcel
    },
    data() {
        return {
            limiteValor: 0,
            produtos: [],
            carrinho: [],
            campanhaAtual: null,
            loteChecked: null,
            progress: null,
            addLote: false,
            datePickerConfig: {
                format: "DD/MM/YYYY",
                showClose: true,
            },
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            marcar: false,
            modalEnvio: false,
            totalEnviado: 0,
            status: "",
            data: 0,
            loading: false,
            loadingTime: 0,
            maxLoadingTime: 3,
            pedidos: [],
            revendedoras: [],
            revendedora: 0,
            fromDate: "",
            toDate: "",
            enviar: [],
            errors: [],
            todosMarcado: false,
            indeterminate: false,
            deletar: 0,
            minimo: 0,
            allSelected: false,
            totalItensSelecionados: 0,
            totalItensIncentivo: 0,
            statusEnvio: 0,
            del: false,
            colunas: [{
                label: " ",
                key: "id",
                class: "text-center",
            },

            {
                label: "Lote",
                key: "lote",
                class: "text-center",
                sortable: true,
            },

            {
                label: "Revendedora",
                key: "nome",
                class: "text-center",
                sortable: true,
            },

            {
                label: "Status",
                key: "status",
                class: "text-center",
            },

            {
                label: "Campanha",
                key: "codigo",
                class: "text-center",
            },

            {
                label: "Criação",
                key: "created_at",
                class: "text-center",
                sortable: true,
                formatter: (value) => {
                    return moment(value).format("DD/MM/YYYY HH:mm:ss")
                }
            },
            {
                label: "Alteração",
                key: "updated_at",
                class: "text-center",
                sortable: true,
                formatter: (value) => {
                    return moment(value).format("DD/MM/YYYY HH:mm:ss")
                }
            },

            {
                label: "Qtd",
                key: "itens",
                class: "text-center",
                sortable: true,
            },

            {
                label: "do Estoque",
                key: "estoque",
                class: "text-center",
            },

            {
                label: "Valor R$",
                key: "total",
                class: "text-center",
                sortable: true,
                sortDirection: 'desc',
                formatter: (value) => {
                    return value ? parseFloat(value).toFixed(2).toString().replace(".", ",") : 0
                }
            },

            {
                label: "Origem",
                key: "observacoes",
                class: "text-center"
            },
            {
                label: "Bonificação",
                key: "bonificacao",
                class: "text-center",
                formatter: (value) => {
                    return value ? "Sim" : "Não"
                }
            },

            {
                label: "",
                key: "opcoes",
                class: "text-center"
            }
            ],
            pedidoMinimo: {},
            isLoading: false,
            recusouBrinde: false,
            distribuidorLogado: {},
            exportPedido: [],
            profile: {
                id: null,
                name: "",
                distribuidor: null,
                classe: null,
                codigo: null,
                pdv: null,
                email: "",
                endereco: {
                    cidade: {
                        id: null,
                        estado: {
                            id: null,
                            uf: "",
                        },
                    },
                },
                contatos: {
                    telefone: {
                        id: 0,
                        ddd: "",
                        numero: "",
                    },
                    telefone: {
                        id: 1,
                        ddd: "",
                        numero: "",
                    }
                },
            },
            /*↓ Confirmar dados cadastro  MC 2↓*/
            cadPopModal: false,
            newPopup: {
            email: null,
            contatos: [
                { telefone: { ddd: null, numero: null} },
                { telefone: { ddd: null, numero: null} }
            ]},
            /*↑ Confirmar dados cadastro ↑*/
        };
    },

    watch: {
        enviar(newValue, oldValue) {
            var vm = this;
            if (newValue.length === 0) {
                vm.indeterminate = false
                vm.todosMarcado = false
            } else if (newValue.length === vm.enviar.length) {
                vm.indeterminate = false
                vm.todosMarcado = true
            } else {
                vm.indeterminate = true
                vm.todosMarcado = false
                vm.changeMarcar(newValue)
            }
        },
    },

    methods: {
        confirmarCarrinho(){
            this.recusouBrinde = this.carrinho.length === 0;

            if((this.limiteValor - this.totalCarrinho) >= 28){
                this.$swal.fire({
                    title: "Confirmação de Envio",
                    html: `<p>Você não utilizou todo o limite de credito em brindes disponivel, tem certeza que deseja prosseguir?</p><p>Limite disponível: <strong>R$ ${this.limiteValor.toFixed(2)}</strong></p><p>Total do carrinho: <strong>R$ ${this.totalCarrinho.toFixed(2)}</strong></p>`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sim, Prosseguir!",
                    cancelButtonText: "Escolher brindes",
                    showCloseButton: true,
                }).then((result) => {
                    if(result.isConfirmed){
                        this.confirmarEnvioPedido();
                        this.$bvModal.hide('chose-modal');
                    }
                })
            } else {
                this.confirmarEnvioPedido();
                this.$bvModal.hide('chose-modal');
            }
        },
        adicionarAoCarrinho(produto) {
            let qtdDesejada = produto.quantidadeTemp && produto.quantidadeTemp > 0 ? produto.quantidadeTemp : 1;
            let precoProduto = Number(produto.pivot.preco);

            if (this.totalCarrinho + (precoProduto * qtdDesejada) > this.limiteValor) {
                return; 
            }

            const itemExistente = this.carrinho.find(item => item.id === produto.id);

            if (itemExistente) {
                itemExistente.quantidade += qtdDesejada;
            } else {
                this.carrinho.push({ ...produto, quantidade: qtdDesejada });
            }

            produto.quantidadeTemp = 1;
        },

        removerDoCarrinho(produto) {
            this.carrinho = this.carrinho.filter(item => item.id !== produto.id);
        },

        validarQuantidadeCarrinho(itemFormatado) {
            if (itemFormatado.quantidade < 1) {
                itemFormatado.quantidade = 1;
            }

            let totalSemEsteItem = this.carrinho.reduce((total, item) => {
                if (item.id === itemFormatado.id) return total;
                return total + (Number(item.pivot.preco) * item.quantidade);
            }, 0);

            let precoDoItem = Number(itemFormatado.pivot.preco);
            let limiteRestante = this.limiteValor - totalSemEsteItem;
            
            let maxQuantidadePermitida = Math.floor(limiteRestante / precoDoItem);

            if (itemFormatado.quantidade > maxQuantidadePermitida) {
                itemFormatado.quantidade = maxQuantidadePermitida;
            }
        },

        /*↓ BOTÃO DE SALVAR - ATUALIZAR DADOS MODAL MC 3 ↓*/
        
        onSubmitCad() {
                const vm = this;

                // Validação de email
                if (!this.profile.email) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "O e-mail é obrigatório",
                        icon: "error",
                    });
                }
                if (!this.profile.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "O email não é válido",
                        icon: "error",
                    });
                }
                const telefone1 = this.profile.contatos[0]?.telefone || {};
                const telefone2 = this.profile.contatos[1]?.telefone || {};
                const numeroValido1 = telefone1.numero && telefone1.numero.replace('(', '').replace(')', '').replace('-', '');
                const numeroValido2 = telefone2.numero && telefone2.numero.replace('(', '').replace(')', '').replace('-', '');
                const dddValido1 = telefone1.ddd && telefone1.ddd.replace('(', '').replace(')', '').replace('-', '');
                const dddValido2 = telefone2.ddd && telefone2.ddd.replace('(', '').replace(')', '').replace('-', '');

                if (dddValido1.length < 2) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 1: Informe pelo menos 2 digitos no DDD",
                        icon: "error",
                    });
                }
                if (dddValido2 < 2) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 2: Informe pelo menos 2 digitos no DDD",
                        icon: "error",
                    });
                }
                if (numeroValido1.length < 8) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 1: O número  tera que ter pelo menos 8 dígitos!",
                        icon: "error",
                    });
                }
                if (numeroValido2 && numeroValido2.length < 8) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 2: O número deve ter pelo menos 8 dígitos!",
                        icon: "error",
                    });
                }

                // DDD e número devem ser preenchidos juntos
                if ((telefone1.ddd && !telefone1.numero) || (telefone1.numero && !telefone1.ddd)) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 1: Preencha o DDD e o número",
                        icon: "error",
                    });
                }

                if ((telefone2.ddd && !telefone2.numero) || (telefone2.numero && !telefone2.ddd)) {
                    return vm.$swal({
                        title: "Atenção",
                        text: "Telefone 2: Preencha o DDD e o número",
                        icon: "error",
                    });
                }

                // Preparar dados para envio
                const dadosAtualizacao = {
                    email: this.profile.email,
                    telefones: []
                };

                // Só adiciona o telefone se DDD e número estiverem preenchidos corretamente
                if (telefone1.ddd && telefone1.numero) {
                    dadosAtualizacao.telefones.push({
                        ddd: telefone1.ddd,
                        numero: telefone1.numero
                    });
                }

                if (telefone2.ddd && telefone2.numero) {
                    dadosAtualizacao.telefones.push({
                        ddd: telefone2.ddd,
                        numero: telefone2.numero
                    });
                }

                axios.post("/atualiza-contato", dadosAtualizacao)
                    .then(response => {
                    console.log(response.data);
                    })
                    .catch(err => {
                    console.error(err);
            });
            },
        
        getCadPopup(){
            this.newPopup.email = this.profile.email;
            this.newPopup.telefone = this.profile.contatos.telefone.numero || '';
            this.cadPopModal = true;
            return this.cadPopModal;
        },
        /*↑ BOTÃO DE SALVAR - ATUALIZAR DADOS MODAL ↑*/
        checkBonificado() {
            const vm = this;
            let bon = false;
            this.enviar.map(item => {
                let _pedido = vm.pedidos.find(el => el.id === item)
                if (_pedido.bonificacao) {
                    bon = true
                }
            })
            return bon
        },
        getProfile() {
            const vm = this;
            axios
                .get("/my-profile")
                .then((response) => {
                    vm.profile = response.data.profile
                    if (vm.status === 'ABERTO' && vm.profile.classe === 'G') {
                        vm.checkLote();
                    }
                });
        },
        showPedido(id) {
            window.open("/distribuidor/pedidos/" + id + "/detalhar", "_blank");
        },

        atualizar() {
            const vm = this;
            window.onbeforeunload = function (e) {
                return this.$swal('Não Atualizar a Página')
            }
            window.onkeydown = function (e) {
                if (e.keyCode === 116) {
                    e.returnValue = false;
                    e.preventDefault();
                    vm.$swal('Atenção, por favor aguarde o processamento dos seus pedidos!', '', 'error')
                    return false;
                }
            }
        },

        initDates() {
            this.toDate = moment()
            this.toDate.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });

            this.fromDate = moment()
            this.fromDate.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });
            this.fromDate.subtract(1, "month")
        },

        /*↓ METODO - ATUALIZAR DADOS MODAL MC 4 ↓*/
        // async abrirModalDados(user) {
        //     console.log('Aqui');
        //     if((this.totalItensSelecionados + this.valor_acao_comercial_enviado) >= this.meta_esperada){
        //         this.$bvModal.show('chose-modal');
        //         return
        //     }

        //     this.newPopup.email = user.email;
        //     this.newPopup.telefone = user.telefone || '';
        //     this.cadPopModal = true;
        // },
        async abrirModalDados(user) {
            try {
                const response = await axios.get('/atualiza-contato');
                const mostrarModal = response.data.mostrar_modal;

                if(this.valor_acao_comercial > 0 && (this.totalItensIncentivo + this.acao_comercial_enviado_itens) >= this.meta_esperada){
                    const response = await axios.post('/distribuidor/pedidos/produtos-acao-comercial', {
                        pedidos: this.enviar
                    });

                    this.produtos = response.data.produtos;
                    const valorItens = response.data.valor_itens;

                    this.limiteValor = (Number(this.acao_comercial_enviado_valor) + Number(valorItens)) * 0.06;

                    this.produtos.forEach(produto => {
                        if (!produto.quantidadeTemp) {
                            this.$set(produto, 'quantidadeTemp', 1);
                        }
                    });

                    this.$bvModal.show('chose-modal');
                    return
                }

                if (mostrarModal) {
                    // Abre o modal normalmente
                    this.newPopup.email = user.email;
                    this.newPopup.telefone = user.telefone || '';
                    this.cadPopModal = true;
                } else {
                    console.log("Usuário com menos de 6 meses desde a ultima alteração. Modal não será exibido.");
                    // Chama a função confirmarEnvioPedido diretamente
                    this.confirmarEnvioPedido();
                }
            } catch (error) {
                console.error('Erro ao verificar dados:', error);
                this.confirmarEnvioPedido(); // Fallback caso ocorra erro
            }
        },
        confirmarEnvioPedido() {
            this.cadPopModal = false;
            this.enviarPedido(); // chama o método original
        },

        async loadingPedidos() {
            const vm = this
            vm.todosMarcado = false
            vm.indeterminate = false
            vm.enviar.length = 0
            vm.totalItensSelecionados = 0
            vm.totalItensIncentivo = 0
            vm.isLoading = true
            this.minimo = $("#quantidade_pedido").val();
            let data = {
                status: this.status,
                revendedora: this.revendedora,
                from: moment(this.fromDate).format("YYYY-MM-DD"),
                to: moment(this.toDate).format("YYYY-MM-DD"),
            };

            try {
                const response = await axios.get("/distribuidor/pedidos/list", {
                    params: data,
                }).then((response) => {
                    vm.pedidos = response.data;
                    vm.totalRows = vm.pedidos.length;
                    vm.isLoading = false
                })
                    .catch(function (error) {
                        var errors = error.response.data.errors;
                        console.log(errors);
                        vm.isLoading = false
                        vm.$swal("Erro", error.response.data.message, "error");
                    });
            } catch (e) {
                console.log("saindo");
                return;
            }
        },

        loadingRevendedoras() {
            var vm = this;
            $(".loading").show();
            axios
                .get("/distribuidor/revendedora/listar")
                .then(function (response) {
                    vm.revendedoras = response.data;
                    $(".loading").hide();
                })
                .catch(function (error) {
                    $(".loading").hide();
                    alert(error.response.data.join("\n")).console.log(error);
                });
        },

        changeData() {
            this.loadingPedidos();
            this.enviar = [];
            this.totalItensSelecionados = 0;
            this.totalItensIncentivo = 0;
        },
        validaPedidoMinimo() {
            this.minimo = this.pedidoMinimo.quantidade_pedido;
            let qtdEnviar = this.checkBonificado() && this.profile.classe === 'G' ? this.enviar.length - 1 : this.enviar.length

            if (qtdEnviar === 0) {
                this.$swal("Atenção", "Selecione um ou mais pedidos.", "error");
                return false;
            }

            /*if ((qtdEnviar > 0) && (qtdEnviar < this.pedidoMinimo.quantidade_pedido) &&  !this.profile.distribuidor.check_itens) {
                this.$swal(
                    "Atenção",
                    "Favor enviar no mínimo " + this.minimo + " pedidos.",
                    "error"
                );
                return false;
            }*/

            let checkMinimoBonificado = this.checkBonificado() && this.enviar.length < 2 ? false : true

            if (checkMinimoBonificado && (this.totalItensSelecionados < this.pedidoMinimo.itens /*&& !this.profile.distribuidor.check_itens*/)) {
                this.$swal(
                    "Atenção",
                    "A quantidade de itens deve ser maior ou igual a  " + this.pedidoMinimo.itens,
                    "error"
                );
                return false
            }

            /*if (this.profile.classe === 'G' && this.totalItensSelecionados < 60 && this.profile.distribuidor.check_itens) {
                this.$swal(
                    "Atenção",
                    "A quantidade de itens deve ser maior ou igual a 60  ",
                    "error"
                );
                return false
            }*/
            return true
        },

        async enviarPedido() {
            const vm = this;

            $(".loading").show();
            for (var m = 0; this.enviar.length > m; m++) {
                const pedido = vm.pedidos.find((pp) => pp.id === parseInt(this.enviar[m]));
                if (pedido) {
                    if (parseInt(vm.campanha_atual) !== pedido.campanha_id) {
                        $(".loading").hide();
                        vm.$swal("Falha no pedido da revendedora " + pedido.nome, "O pedido não pertence a campanha atual. Favor alterar o pedido para prosseguir", "error");
                        return;
                    };
                };

                if (vm.pedidoMinimo.classe === 'G' && vm.pedidoMinimo.restricao === 'VALOR' && (pedido.itens < vm.pedidoMinimo.itens || pedido.total < vm.pedidoMinimo.valor) && !pedido.bonificacao) {
                    $(".loading").hide();
                    vm.$swal("Falha no pedido da revendedora " + pedido.nome, "O Valor mínimo deve ser R$ 110,00", "error");
                    return;
                }
            };

            if (vm.checkBonificado() && !vm.loteChecked && vm.enviar.length < 2 && vm.profile.classe === 'G') {
                vm.$swal("Atenção", "O pedido bonificado deve ser anexado a outro lote ou enviado com outro pedido!", "error");
                $(".loading").hide();
                return
            }
            
            if (vm.checkBonificado() && vm.loteChecked && vm.enviar.length < 2 && vm.profile.classe === 'G') {
                vm.addLote = true
            }
            $(".loading").hide();
            vm.$swal.fire({
                title: "Deseja enviar os " + vm.enviar.length + " pedidos selecionados?",
                html: `<ul> Estamos recebendo pedidos referente ao mês de ` + vm.getMes + ` - Campanha ${vm.campanhaAtual} </ul>`,
                footer: "Não atualize a página até que todos os pedidos sejam enviados!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Enviar!",
                cancelButtonText: "Não, Sair",
                showCloseButton: true,
            }).then((result) => {
                if (result.value) {
                    if (vm.loteChecked && ((!vm.loteChecked.cashback || vm.loteChecked.cashback == 0) && (!vm.loteChecked.pedido_estoque || vm.loteChecked.pedido_estoque == 0) && (!vm.loteChecked.pedido_lancamento || vm.loteChecked.pedido_lancamento == 0)) && vm.profile.classe === 'G' && !vm.addLote) {
                        let denyButton = (vm.checkBonificado() && vm.loteChecked && vm.enviar.length < 2) ? false : true
                        vm.$swal.fire({
                            title: "Atenção",
                            html: "<h5>Você pode anexar esse(s) pedido(s) ao lote <b> " + vm.loteChecked.codigo + "</b> </h5><br>" +
                                "<h4><strong>Deseja anexar? </strong></h4>",
                            footer: "Ao gerar um novo lote, poderá ser cobrado um novo frete!",
                            icon: "question",
                            showCancelButton: true,
                            showDenyButton: denyButton,
                            denyButtonText: `Não! Novo lote`,
                            denyButtonColor: "#008000",
                            confirmButtonText: "Sim!",
                            cancelButtonText: "Cancelar",
                            cancelButtonColor: "#FF6347",
                            showCloseButton: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                vm.addLote = true
                            }
                            if (result.isDenied || result.isConfirmed) {
                                vm.confirmaEnvio();
                            }
                        });
                    } else {
                        vm.confirmaEnvio();
                    }
                }
            });
        },

        async confirmaEnvio() {
            const vm = this;
            if (!vm.addLote && !this.validaPedidoMinimo()) {
                return
            }
            vm.modalEnvio = true;
            document.addEventListener("keydown", vm.atualizar())
            var lote_id = null
            let pedidos = this.enviar.map((el) => {
                const data = {
                    loteChecked: vm.loteChecked,
                    addLote: vm.addLote,
                    pedido: el,
                    lote_id: lote_id
                };
                return data
            })

            axios.post("/distribuidor/pedidos/enviar", { pedidos: pedidos, brindes: vm.carrinho, recusouBrinde: vm.recusouBrinde })
                .then((response) => {
                    if (response) {
                        vm.enviar = [];
                        vm.addLote = false;
                        vm.checkLote();
                        vm.loadingPedidos();
                        vm.$swal.fire({
                            title: "Parabéns!",
                            text: "Pedidos enviados com sucesso",
                            icon: "success"
                        })
                    }
                }).catch((error) => {
                    console.log(error.response);
                    vm.$swal.fire({
                        title: "Atenção",
                        text: error.response.data,
                        icon: "error"
                    })
                }).finally(() => {
                    document.removeEventListener("keyup", vm.atualizar())
                    window.location.reload();
                    vm.modalEnvio = false;
                })
        },

        checkLote() {
            const vm = this;
            axios.get('/lotes/checklote')
                .then((response) => {
                    if (response.data) {
                        if (response.data.id) {
                            vm.loteChecked = response.data;
                        } else {
                            vm.loteChecked = null
                        }
                    }
                }).catch((erro) => {
                    console.log(erro);
                })
        },
        recuperarDeletados() {
            const vm = this;
            if (vm.enviar.length == 0) {
                vm.$swal.fire(
                    "Atenção",
                    "Selecione ao menos um pedido, para recuperar.",
                    "error"
                );
                // console.log("erro .. nenhum pedido selecionado.");
                return;
            }
            vm.$swal.fire({
                title: "Existem " + vm.enviar.length + " pedidos selecionados!",
                text: "Deseja recuperar o(s) pedido(s) selecionado(s)?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Recuperar!",
                cancelButtonText: "Não, Sair",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    vm.enviar.forEach((it) => {
                        vm.recoveryPedido(it);
                    });
                }
            });
        },
        deletarPedido(id) {
            this.deletar = id;
            const vm = this;
            if (vm.enviar.length == 0) {
                vm.$swal.fire("Atenção", "Selecione ao menos um pedido, para deletar.", "error");
                // console.log("erro .. nenhum pedido selecionado.");
                return;
            }
            vm.$swal.fire({
                title: "Existem " + vm.enviar.length + " pedidos selecionados!",
                text: "Realmente deseja deletar todo(s) ele(s) ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Deletar!",
                cancelButtonText: "Não, Sair",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    vm.comfirmaDelete()
                }
            });
        },

        deletarPedidoLinha(id) {
            this.deletar = id;
            var vm = this;
            this.$swal({
                title: "Deseja realmente deletar o pedido?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Deletar!",
                cancelButtonText: "Não, Sair",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    $(".loading").show();
                    vm.del = true
                    vm.confirmaDeleteLinha(id)
                }
            });
        },
        comfirmaDelete() {
            var vm = this;
            $(".loading").show();
            if (vm.del == false) {
                vm.enviar.forEach(function (a) {
                    axios
                        .get("/distribuidor/pedidos/" + a + "/deletar")
                        .then(function (response) {
                            $(".loading").hide();
                            vm.loadingPedidos();
                        })
                        .catch(function (error) {
                            $(".loading").hide();
                            vm.$swal("Ops", response.data.errors.join("\n"), "error");
                        });
                });
            }
        },
        confirmaDeleteLinha(id) {
            var vm = this
            axios
                .get("/distribuidor/pedidos/" + id + "/deletar")
                .then(function (response) {
                    $(".loading").hide();
                    vm.loadingPedidos();
                })
                .catch(function (error) {
                    $(".loading").hide();
                    vm.$swal("Ops", response.data.errors.join("\n"), "error");
                });
        },
        async recoveryPedido(id) {
            const vm = this;
            $(".loading").show();
            let data = {
                _method: "PUT",
                id: id,
                acao: "RECOVERY",
            };

            try {
                const response = await axios
                    .post("/distribuidor/pedidos/" + id, data)
                    .catch((error) => {
                        vm.$swal(error.response.data.errors.join("\n"), "", "error");
                    });
                if (response) {
                    $(".loading").hide();
                    vm.loadingPedidos();
                }
            } catch (e) {
                $(".loading").hide();
                console.log(e);
                return;
            }
        },

        changeMarcarTodos(marcar) {
            var vm = this
            if (!marcar) {
                vm.enviar = []
                vm.totalItensSelecionados = 0;
                vm.totalItensIncentivo = 0;
                return;
            }
            this.pedidos.forEach(function (pedido) {
                if (
                    marcar &&
                    (pedido.status === "ABERTO" || pedido.status === "DELETADO") &&
                    vm.enviar.indexOf(pedido.id) < 0
                ) {
                    if (!pedido.bonificacao) {
                        vm.totalItensSelecionados += parseInt(pedido.itens);
                        vm.totalItensIncentivo += parseInt(pedido.itens_incentivo);
                    }
                    vm.changeQtdItensSelecionados(pedido.id)
                }
            });
        },
        changeMarcar(i) {
            const vm = this;
            /*var index = vm.enviar.indexOf(id);
            if(index < 0){
                return
            }*/
            var total = 0
            var totalIncentivo = 0

            this.enviar.map(item => {
                let _pedido = vm.pedidos.find(el => el.id === item)
                if (_pedido && !_pedido.bonificacao) {
                    total += parseInt(_pedido.itens)
                    totalIncentivo += parseInt(_pedido.itens_incentivo)
                }
            })
            this.totalItensSelecionados = total
            this.totalItensIncentivo = totalIncentivo
        },

        changeQtdItensSelecionados(marcar) {
            var vm = this;
            var index = vm.enviar.indexOf(marcar);
            if (index > -1) {
                vm.enviar.splice(index, 1);
            } else {
                vm.enviar.push(marcar);
            }
        },

        editPedido(item) {
            if (item.brindes) {
                this.$swal({
                    title: "Atenção!",
                    html: "<span>Este pedido possui incentivos!" +
                        "<br> Ao continuar os incentivos serão perdidos e será necessário adicioná-los novamente!" +
                        "<br><br><h4> Deseja continuar? </h4> <span> ",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sim, Continuar!",
                    cancelButtonText: "Não, Cancelar",
                    showCloseButton: true,
                }).then((result) => {
                    if (result.value) {
                        $(".loading").show();
                        axios
                            .post("/distribuidor/pedidos/incentivo/excluir/" + item.id)
                            .then(function (response) {
                                $(".loading").hide();
                                window.location.href = "/distribuidor/pedidos/" + item.id + "/edit";
                            })
                            .catch(function (error) {
                                alert("Erro ao excluir incentivo");
                                console.log(error);
                                $(".loading").hide();
                            });
                    }
                });
            } else {
                window.location.href = "/distribuidor/pedidos/" + item.id + "/edit";
            }
        },

        async startDownload(id) {
            let valida = false;
            const resposta = await axios.get("/distribuidor/relatorio/excel/" + id + "/detalhar")
                .then(function (response) {
                    $(".loading").hide();
                    valida = true;
                    return response;
                })
                .catch(function (error) {
                    $(".loading").hide();
                    console.log(error);
                    return alert("Erro ao gerar o relatório");
                })

            if (valida) {
                return resposta.data;
            }

        },
        exportExcel() {
            $(".loading").show()
        },
        finishExcel() {
            $(".loading").hide()
        },
        loadPedidoMinimo() {
            var vm = this;
            $(".loading").show();
            axios
                .get("/distribuidor/pedidominimo")
                .then((response) => {
                    vm.pedidoMinimo = response.data;
                    $(".loading").hide();
                })
                .catch((error) => {
                    alert("Erro ao carregar Pedido Minimo");
                    console.log(error);
                    $(".loading").hide();
                });
        },
        async getCampanhaAtual() {
            const vm = this;
            await axios
                .get("/distribuidor/campanha/atual")
                .then((response) => {
                    vm.campanhaAtual = response.data.campanha.codigo;
                })
                .catch((erro) => {
                    console.log(erro);
                });
        },
    },

    computed: {
        totalCarrinho() {
            return this.carrinho.reduce((total, item) => {
                return total + (Number(item.pivot.preco) * Number(item.quantidade));
            }, 0);
        },

        progressoVariante() {
            const porcentagem = (this.totalCarrinho / this.limiteValor) * 100;
            if (porcentagem >= 100) return 'danger';
            if (porcentagem >= 80) return 'warning';
            return 'success';
        },
        acao_comercial_enviado_itens(){
            return this.acao_comercial?.qtd_itens_mes_atual ?? 0;
        },
        acao_comercial_enviado_valor(){
            return this.acao_comercial?.vlr_itens_mes_atual ?? 0;
        },
        valor_acao_comercial(){
            return this.acao_comercial?.qtd_itens_ultimo_mes ?? 0;
        },
        getMes() {
            return moment(this.pedidoMinimo.data_fechamento.date).format('MMMM');
        },
        meta_esperada(){
            return Math.ceil(this.valor_acao_comercial * 1.1);
        },
        porcentagem_concluida(){
            if (this.meta_esperada === 0) return 0
  
            const percentual = (this.totalItensIncentivo + this.acao_comercial_enviado_itens) / this.meta_esperada * 100;
            return Math.min(Math.round(percentual), 100)
        },
        filename() {
            const data = new Date();
            return `${data.getTime()}.xls`;
        },

        porcent() {
            var vm = this;
            return ((vm.statusEnvio / vm.enviar.length) * 100).toFixed(0);
        },

        isCampanhaAtual() {
            return true;
        },

        loadProgresso() {
            return this.statusEnvio;
        },

        dataTable() {
            var data = this.pedidos;
            return data;
        },
        computedStatus() {
            if (this.status == "") {
                return "TODOS";
            } else {
                return this.status;
            }
        },
        isOrderASC() {
            if (this.sortOrder === "ASC") {
                return true;
            }
            return false;
        },
        showPedidoExport() {
            return this.exportPedido;
        }
    },

    created() {
        this.initDates();
        this.status = $("#status").val();
        this.loadPedidoMinimo();
    },
    mounted() {
        this.getCampanhaAtual();
        this.loadingPedidos()
        this.loadingRevendedoras()
        this.getProfile();
        /*↓ MOUNTED - ATUALIZAR DADOS MODAL  MC 5↓*/
        this.profile.contatos.telefone.numero.ddd =
        this.profile.contatos.telefone.ddd ?
        this.profile.contatos.telefone.ddd : (this.profile ? this.profile.contatos.telefone.ddd : "");
        this.profile.contatos.telefone.numero =
        this.profile.contatos.telefone.numero ?
        this.profile.contatos.telefone.numero :(this.profile ? this.profile.contatos.telefone.numero : "");
    },
};
</script>

<style scoped>
.label-status {
    font-size: 1.2em;
}

.overlay-brindes {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(1px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.card-acao-comercial {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  font-family: sans-serif;
}

.cabecalho-acao {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.icone {
  font-size: 1.25rem;
}

.titulo {
  margin: 0;
  color: #1e293b;
  font-size: 1.1rem;
  font-weight: 600;
}

.descricao {
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.texto-mutado {
  display: block;
  color: #94a3b8;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.info-progresso {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #334155;
}

.porcentagem {
  font-weight: bold;
  color: #10b981;
}

.barra-fundo {
  background-color: #e2e8f0;
  border-radius: 9999px;
  height: 12px;
  width: 100%;
  overflow: hidden;
}

.barra-preenchimento {
  background-color: #10b981;
  height: 100%;
  border-radius: 9999px;
  transition: width 0.5s ease-in-out;
}

.product-img {
    height: 160px;
    object-fit: cover;
    border-top-left-radius: calc(.25rem - 1px);
    border-top-right-radius: calc(.25rem - 1px);
}

/* Efeito de hover nos cards de produto */
.product-card {
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15) !important;
}

/* Tamanho do input de quantidade no carrinho */
.cart-qty-input {
    width: 60px;
    padding: 0.25rem;
}

/* Permite que o carrinho faça scroll interno se tiver muitos itens */
.cart-scroll-area {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Customização simples de barra de rolagem (opcional) */
.cart-scroll-area::-webkit-scrollbar {
    width: 6px;
}
.cart-scroll-area::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
.cart-scroll-area::-webkit-scrollbar-thumb {
    background: #c1c1c1; 
    border-radius: 4px;
}
.cart-scroll-area::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8; 
}

/* Animação suave para o aviso de limite */
.fade-in {
    animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pedidos/Main.vue